<template>
	<transition name="slide-fade">
	<div class="users">
		<img src="../../static/close.png" alt="" @click="back">
		<main>
			<div class="bold">
				<div>Пользователь</div>
				<div>Оператор</div>
			</div>
			<div v-for="(user,i) in users"
			     class="cont"
			     @click="edit(i)"
			     :key="user.login + user.operator">
				<div>{{user.login}}</div>
				<div>{{user.operator}}</div>
			</div>
		</main>
	</div>
	</transition>
</template>
<script>
	
	import { mapGetters, mapMutations } from "vuex";

	export default {
		name:     "UpdateUsers",
		data() {
			return {
				users: {}
			};
		},
		beforeMount() {
			this.users = this.getUsersApp;
			console.log(this.users);
		},
		computed: {
			...mapGetters(["getUsersApp"])
		},
		methods:  {
			...mapMutations(["setThisUserApp"]),
			back() {
				this.$router.push('/auth')
			},
			edit(i) {
				this.setThisUserApp(this.users[i]);
				this.$router.push('/edit_user_app')
			}
		}
	};
</script>
<style scoped lang="scss">
	.users {
		position: absolute;
		margin-top: 5rem;
		width: 30rem;
		background-color: rgba(238, 238, 238, 0.8);
		border-radius: 0.5rem;
		right: 50%;
		transform: translateX(50%);
		box-shadow: inset 0 0 5px #333333;
		display: flex;
		align-items: center;
		justify-content: center;
		img {
			width: 30px;
			height: 30px;
			position: absolute;
			right: 10px;
			top: 10px;
			cursor: pointer;
		}
		main {
			width: 20rem;
			padding: .5rem;
			.cont {
				padding: .4rem;
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				transition: all .3s;
				cursor: pointer;
				&:hover {
					background-color: #ffd8b5;
				}
			}
			.bold {
				padding: .4rem;
				display: flex;
				flex-direction: row;
				justify-content: space-between;
				transition: all .3s;
				font-weight: 600;
				margin-bottom: 1rem;
			}
		}
		
	}
	.slide-fade-enter-active {
		transition: all 0.3s ease;
	}
	.slide-fade-leave-active {
		transition: all 0.3s ease;
	}
	.slide-fade-enter, .slide-fade-leave-to {
		transform: translateX(10px);
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/UpdateUsers.vue